export const LOG_CHECK_TAB_DATA = 'LOG_CHECK_TAB_DATA';
export const GET_GENERAL_SYSTEM_PARAMETER = 'GET_GENERAL_SYSTEM_PARAMETER';
export const ADD_NEW_LOG_CHECK = 'ADD_NEW_LOG_CHECK';
export const SAVE_OR_UPDATE = 'SAVE_OR_UPDATE';
export const SAVE_AFTER_LIST_DATA = 'SAVE_AFTER_LIST_DATA';
